import { render, staticRenderFns } from "./HistoricSearchModal.vue?vue&type=template&id=2a13a70c&scoped=true&"
import script from "./HistoricSearchModal.vue?vue&type=script&lang=js&"
export * from "./HistoricSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoricSearchModal.vue?vue&type=style&index=0&id=2a13a70c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13a70c",
  null
  
)

export default component.exports